interface Props {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
}

export const CreditCardIcon = ({
  width = 15,
  height = 15,
  color = "#000000",
  className,
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 15 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M13.5575 0H1.44187C0.647334 0 0 0.646603 0 1.44187V2.50074H14.9972V1.44187C14.9972 0.647334 14.352 0 13.5575 0Z"
      fill={color}
    />
    <path
      d="M0 8.55839C0 9.35292 0.646603 10.0003 1.44187 10.0003H13.556C14.3505 10.0003 14.9957 9.35365 14.9957 8.55839V3.11816H1.87719e-05L0 8.55839ZM1.84829 5.85702C1.84829 5.5663 2.08481 5.33051 2.37699 5.33051H3.78883C4.08101 5.33051 4.31534 5.56703 4.31534 5.85702V6.54537C4.31534 6.83756 4.08101 7.07408 3.78883 7.07408H2.37699C2.08481 7.07408 1.84829 6.83756 1.84829 6.54537V5.85702Z"
      fill={color}
    />
    <defs>
      <linearGradient
        id="paint0_linear_6991_152905"
        x1="0.322289"
        y1="0.150907"
        x2="14.9996"
        y2="2.48542"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={color} />
        <stop offset="1" stopColor={color} />{" "}
      </linearGradient>
      <linearGradient
        id="paint1_linear_6991_152905"
        x1="0.322257"
        y1="3.53346"
        x2="15.3193"
        y2="4.40015"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={color} />
        <stop offset="1" stopColor={color} />{" "}
      </linearGradient>
    </defs>
  </svg>
);
